/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_ListingsInputs */

const en_search_listings = /** @type {(inputs: Search_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search listings...`)
};

const id_search_listings = /** @type {(inputs: Search_ListingsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari listing...`)
};

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const es_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const fr_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const de_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const ja_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const zh_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const ar_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const it_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const ru_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const pt_search_listings = en_search_listings;

/** @type {(inputs: Search_ListingsInputs) => LocalizedString} */
const ko_search_listings = en_search_listings;

/**
* | output |
* | --- |
* | "Search listings..." |
*
* @param {Search_ListingsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_listings = /** @type {((inputs?: Search_ListingsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_ListingsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_listings(inputs)
	if (locale === "es") return es_search_listings(inputs)
	if (locale === "fr") return fr_search_listings(inputs)
	if (locale === "de") return de_search_listings(inputs)
	if (locale === "ja") return ja_search_listings(inputs)
	if (locale === "zh") return zh_search_listings(inputs)
	if (locale === "ar") return ar_search_listings(inputs)
	if (locale === "id") return id_search_listings(inputs)
	if (locale === "it") return it_search_listings(inputs)
	if (locale === "ru") return ru_search_listings(inputs)
	if (locale === "pt") return pt_search_listings(inputs)
	return ko_search_listings(inputs)
});